import { createContext } from 'react';

export const useGridContext = createContext();
